__turbopack_context__.v({
  "discount": "ErvwPa_discount",
  "flag": "ErvwPa_flag",
  "seller": "ErvwPa_seller",
});
